var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "data-value copy-element" },
    [
      _c(
        "CompassLink",
        {
          attrs: { label: _vm.phoneNumber, link: _vm.formattedPhoneNumberLink }
        },
        [_vm._v("\n        " + _vm._s(_vm.phoneNumber) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.phoneNumber
        ? _c("SaasClipboard", { attrs: { data: _vm.phoneNumber } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }